<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 6299 6299"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <rect class="fil0" width="6299" height="6299" rx="614" ry="614"/>
     <g id="_819373216">
     <g>
      <circle class="fil1 str0" cx="3111" cy="1493" r="158"/>
       <g>
       <circle class="fil1 str0" cx="4945" cy="1493" r="158"/>
         <circle class="fil1 str0" cx="1278" cy="1493" r="158"/>
      </g>
     </g>
       <g>
      <circle class="fil1 str0" cx="3111" cy="4793" r="158"/>
         <g>
       <circle class="fil1 str0" cx="4945" cy="4793" r="158"/>
           <circle class="fil1 str0" cx="1278" cy="4793" r="158"/>
      </g>
     </g>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'TouchGlass',
};
</script>

<style scoped>
.str0 {
  stroke: #FEFEFE;
  stroke-width: 54.6316
}

.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
